import TooltipNew from './views/TooltipNew.c';
export default TooltipNew;
